import { createFileRoute, redirect } from '@tanstack/react-router';

import { LandingPage } from '@/components/landing/landing-page';
import { meQueryOptions } from '@/hooks/data/use-auth';
import { hasSeenPaywall } from '@/lib/paywall-seen';
import { getRedirectPath } from '@/lib/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/')({
  loader: () => loadNamespaces('landing'),
  beforeLoad: async ({ context, location }) => {
    const user = await context.queryClient
      .fetchQuery(meQueryOptions)
      .catch(() => null);
    if (!user) return;

    const target = getRedirectPath({
      pathname: location.pathname,
      user,
      paywallSeen: hasSeenPaywall(user.organization_id),
    });
    if (target) {
      // TanStack Router uses thrown non-Error redirects as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: target, replace: true });
    }
  },
  component: LandingPage,
});
